import React from 'react'
import {Route, Redirect, Switch} from 'react-router-dom'

import DashboardItem from '../etc/dashboard-item'
import inFullScreen from '../hoc/full-screen'

import TaskStatus from '../components/TaskStatus'
import DatasetHome from '../containers/DatasetHome'

import NakedTaskList from '../components/TaskList'
import {chartSizes, framework as appTheme} from '../etc/theme'

const DatasetRoutes = ({dataset, match, history}) => { 

  let home_url = match.url
  let home_path = match.path
  return  (
  <Switch>
    <Route exact path={`${home_path}/list`} render={(props) => (
      <DatasetHome {...props} base_url={home_url}/>
    )}
     />

    { DashboardItem.cases.map(item=>{
      
      const path = `${home_path}/${item.route}`
      const item_url  = `${home_url}/${item.route}`      

      let {Homepage: NakedHomepage, Filter, fields, filteredTasksSelector, defaultFilter} = item.parts
      let route = item.title

      let Homepage = inFullScreen(item.title, home_url)(NakedHomepage)

      return(
        <Route key={route} path={path} render={({match}) =>(
          <Switch>
            <Route 
              path={`${match.path}/:currentFilter`} 
              render={({match})=>{
                
                const currentFilter = Filter.fromRawValue(match.params.currentFilter)
                const TaskList = inFullScreen(currentFilter.title, item_url)(NakedTaskList)
                return(<TaskList 
                  currentFilter={currentFilter}
                  onSetFilter={(filter)=>{history.replace(`${item_url}/${filter.rawValue}`)}}
                  tasks={filteredTasksSelector(dataset, currentFilter)} 
                  fields={fields} 
                />)}
              }
            />
            <Route 
              path={match.url} 
              exact         
              render={({match})=>(<Homepage 
                dataset={dataset} 
                onSetFilter={(filter)=>{history.push(`${item_url}/${filter.rawValue}`)}}
                currentFilter={defaultFilter}
              />)}
            />
          </Switch>
        )}/>
    

    )})}
    <Redirect from={`${match.url}`} to={`${match.url}/list`} />
  </Switch>
)}

export default DatasetRoutes



// WEBPACK FOOTER //
// ./src/routes/dataset.js